import { ON_CONVERSATION_UNENDED_EVENT_TYPE } from 'core/constants';
import { runListenersForEvent } from 'core_main/globals/events';
import { getKustomerMainObject } from 'core_main/globals/helpers';
import { createEndConversationCallbackResponse } from 'core_main/sdk/end_conversation/helpers';
import { PubNubSessionUpdateMessageEvent } from '../types';

export const handleChatSessionUpdateEvent = (
  message: PubNubSessionUpdateMessageEvent,
) => {
  const lockedAtOp = message?.data?.changes?.attributes?.lockedAt?.op;

  const before = message?.data?.before;
  const after = message?.data?.after;

  const beforeCustomerId = before?.relationships?.customer?.data?.id;
  const afterCustomerId = after?.relationships?.customer?.data?.id;

  if (
    beforeCustomerId &&
    beforeCustomerId !== afterCustomerId &&
    afterCustomerId
  ) {
    setTimeout(() => {
      const kustomerMain = getKustomerMainObject();
      kustomerMain.login();
    }, 400);
  }

  if (!lockedAtOp) return;

  if (lockedAtOp === 'remove') {
    const callbackResponse = createEndConversationCallbackResponse(after);

    runListenersForEvent(ON_CONVERSATION_UNENDED_EVENT_TYPE, callbackResponse);
  }
};
